const initialState = {
  isRxAvailable: true,
  isRxRequired: true,
  rxDelivery: false,
  rxSms: false,
  rxEmail: false,
  emailadd: '',
  doctorConsultationNotes:'',
};
import * as Constants from '../constants';

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.SET_RX_AVAILABILITY_STATE:
      return Object.assign(action.data);
    default:
      return { ...state };
  }
}
